export default __webpack_public_path__ + "static/media/logo1.ba4e4c77.png";